module.exports = __webpack_public_path__ + "img/home_lottery_type1.232aa18b.png";